module.exports = __webpack_public_path__ + "static/4328788-c7edaa1077392b81062e2d66445da5c1.mp4";